import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/img/icon/plus.svg';
import _imports_1 from '@/img/icon/arrow-order.svg';
const _withScopeId = n => (_pushScopeId("data-v-3a751799"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "addition"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h5", {
  class: "addition-title"
}, "Рекомендуем добавить", -1));
const _hoisted_3 = {
  class: "swiper-object-4"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "addition-slider__imgwrapper"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "addition-slider__title"
};
const _hoisted_8 = {
  key: 0,
  class: "addition-slider__text"
};
const _hoisted_9 = {
  key: 1,
  class: "addition-slider__text"
};
const _hoisted_10 = {
  class: "addition-slider__box"
};
const _hoisted_11 = {
  class: "addition-slider__price"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "грн", -1));
const _hoisted_13 = ["onClick"];
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_15 = [_hoisted_14];
const _hoisted_16 = {
  class: "navigation"
};
const _hoisted_17 = {
  ref: "prev",
  class: "addition-slider-prev"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1));
const _hoisted_19 = [_hoisted_18];
const _hoisted_20 = {
  ref: "next",
  class: "addition-slider-next"
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1));
const _hoisted_22 = [_hoisted_21];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_swiper_slide = _resolveComponent("swiper-slide");
  const _component_swiper = _resolveComponent("swiper");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createVNode(_component_swiper, {
    class: "addition-slider",
    modules: $setup.modules,
    "slides-per-view": 4,
    "slides-per-group": 3,
    "space-between": 20,
    navigation: {
      prevEl: $setup.prev,
      nextEl: $setup.next
    }
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.slides, item => {
      return _openBlock(), _createBlock(_component_swiper_slide, {
        key: item.id
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          class: "addition-slider__slide",
          onClick: $event => _ctx.$router.push(`/rol-shop/${item.category}/${item.id}`)
        }, [_createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
          class: "addition-slider__img",
          src: require(`@/img/products/${item.imgUrl}`),
          alt: "product"
        }, null, 8, _hoisted_6)]), _createElementVNode("h6", _hoisted_7, _toDisplayString(item.title), 1), item.weight ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(item.weight) + " г", 1)) : (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(item.volume) + " л", 1)), _createElementVNode("div", _hoisted_10, [_createElementVNode("p", _hoisted_11, [_createTextVNode(_toDisplayString(item.price), 1), _hoisted_12])])], 8, _hoisted_4), _createElementVNode("button", {
          class: _normalizeClass(["addition-slider__btn", {
            'addition-slider__btn--added': item.isAdded
          }]),
          onClick: $event => _ctx.$emit('orderAddCart', item)
        }, _hoisted_15, 10, _hoisted_13)]),
        _: 2
      }, 1024);
    }), 128))]),
    _: 1
  }, 8, ["modules", "navigation"]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, _hoisted_19, 512), _createElementVNode("div", _hoisted_20, _hoisted_22, 512)])])]);
}